<template>
    <div>
        <v-dialog persistent v-model="dialog" width="600px">
        <v-card width="600px">
            <v-card-title style="background: #455a64; color: white">
            <span class="font-weight-black;">STOPチェック依頼</span>
            </v-card-title>
                <v-card-text>
                    <div class="ml-2">
                        <span>STOPチェック依頼</span>
                            <v-radio-group
                            v-model="stopFirstSelection"
                            row
                            hide-details
                            >
                            <v-radio
                                label="あり"
                                value="1"
                            ></v-radio>
                            <v-radio
                                label="なし"
                                value="0"
                            ></v-radio>
                        </v-radio-group>
                    </div>
                    <div class="ml-2">
                        <span>施工連絡</span>
                            <v-radio-group
                            :disabled="stopFirstSelection != '1'"
                            v-model="stopSecondSelection"
                            row
                            hide-details
                            >
                            <v-radio
                                label="あり"
                                value="1"
                            ></v-radio>
                            <v-radio
                                label="なし"
                                value="0"
                            ></v-radio>
                        </v-radio-group>
                    </div>

                    <!-- <div class="ml-2" v-show="stopSecondSelection == '1'">
                        <template v-for="(item, index) of stopSelections" >
                            <v-row no-gutters :key="index" v-if="item.category == cadRequestBasicInformation.house_type_category" >
                                <v-col cols="1">
                                    <v-checkbox :disabled="stopSecondSelection != '1'" v-model="item.isChecked"></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <v-autocomplete :disabled="stopSecondSelection != '1'" v-model="item.selected" :items="STOP_LIST" item-text="text" item-value="id" hide-details outlined dense></v-autocomplete>
                                </v-col>
                            </v-row>
                        </template>
                    </div> -->

                    <div class="ml-2" v-show="stopSecondSelection == '1'">
                        <template v-for="(item, index) of newSelection" >
                            <v-row no-gutters :key="index">
                                <v-col cols="1">
                                    <v-checkbox :disabled="stopSecondSelection != '1'" v-model="item.isChecked"></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <v-autocomplete :disabled="stopSecondSelection != '1'" v-model="item.selected" :items="STOP_LIST" item-text="text" item-value="id" hide-details outlined dense></v-autocomplete>
                                </v-col>
                            </v-row>
                        </template>
                        <template>
                            <v-row no-gutters v-for="(item, index) in additionalStop" :key="index+'a'">
                                <v-col cols="1">
                                    <v-checkbox v-model="item.isChecked"></v-checkbox>
                                </v-col>
                                <v-col cols="10">
                                    <v-text-field v-model="item.text" hide-details outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="1"></v-col>
                                <v-col cols="10">
                                    <v-btn @click="addSekou()" block dense dark color="primary">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn dark color="red" @click="cancelSubmit">キャンセル</v-btn>
                        <v-btn dark color="green" @click="submitStop" >保存</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
export default {
    props: {
        dialog: Boolean
    },
    data: () => ({
        additionalStop:[],
        stopFirstSelection: null,
        stopSecondSelection: null,
        newSelection: [],
        stopSelections: [
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 1,
                category: 2,
                rowCount: 1,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 2,
                category: 2,
                rowCount: 2,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 3,
                category: 2,
                rowCount: 3,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 4,
                category: 2,
                rowCount: 4,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 6,
                category: 2,
                rowCount: 5,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 7,
                category: 2,
                rowCount: 6,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 8,
                category: 2,
                rowCount: 7,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 9,
                category: 2,
                rowCount: 8,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 10,
                category: 2,
                rowCount: 9,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 11,
                category: 2,
                rowCount: 10,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 12,
                category: 2,
                rowCount: 11,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 13,
                category: 2,
                rowCount: 12,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 14,
                category: 2,
                rowCount: 13,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 15,
                category: 2,
                rowCount: 14,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 16,
                category: 3,
                rowCount: 15,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 17,
                category: 3,
                rowCount: 16,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 18,
                category: 3,
                rowCount: 17,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 19,
                category: 3,
                rowCount: 18,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 20,
                category: 3,
                rowCount: 19,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 21,
                category: 3,
                rowCount: 20,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 22,
                category: 3,
                rowCount: 21,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 23,
                category: 3,
                rowCount: 22,
                text: '',
            },
            {
                option1: null,
                option2: null,
                isChecked: false,
                selected: 24,
                category: 3,
                rowCount: 23,
                text: '',
            },
        ]
    }),
    
    mounted() {
        this._getStopList()
    },

    computed:{
        ...mapState([
            'STOP_LIST',
            'cadRequestBasicInformation',
            'stopListSelection',
        ]),
    },

    methods: {
        ...mapActions([
            '_getStopList',
        ]),
        addSekou(){
            this.additionalStop.push({
                option1 : '1',
                option2 : '1',
                isChecked : null,
                selected : null,
                category : null,
                rowCount : null,
                text: '',
            })
        },
        cancelSubmit(){
            this.toggleDialogStop(false);
        },
        submitStop(){
            let checked = []
                if(this.stopSecondSelection == '1'){
                    this.newSelection.filter((res) => {
                        if(res.isChecked){
                            res.option1 = this.stopFirstSelection;
                            res.option2 = this.stopSecondSelection;
                            res.text = this.STOP_LIST.find((r) => r.id === res.selected)?.text;
                            checked.push(res)
                        }else{

                        }
                    })
                }
                else{
                    let data = {
                            option1: this.stopFirstSelection,
                            option2: this.stopSecondSelection,
                            isChecked: null,
                            selected: null,
                            category: null,
                            rowCount: null,
                            text: '',
                        };
                    checked.push(data)
                }
            if(this.additionalStop.length > 0) {
                this.additionalStop.filter((r) => {
                    if(r.isChecked){
                        checked.push(r)
                    }
                })
            } 
            if(checked.length == 0){
                checked.push({
                    option1: this.stopFirstSelection,
                    option2: this.stopSecondSelection,
                    isChecked: null,
                    selected: null,
                    category: null,
                    rowCount: null,
                    text: '',
                })
            }

            // return console.log(checked)

            this.$emit('submitStop', checked)
            this.toggleDialogStop(false)
            console.log(checked, 'checked')
            
        },
        
        toggleDialogStop(value){
            this.$emit('toggleDialogStop', value)
        },
  },
  watch: {
    stopFirstSelection(val){
        if(val == '0'){
            this.stopSecondSelection = null;
        }
    },
    dialog(val){
        if(val){
            this.newSelection = [];
            this.STOP_LIST.filter((res) => {
                if (res.house_type_category == this.cadRequestBasicInformation.house_type_category) {
                    let data = {
                        selected : res.id,
                        option1 : null,
                        option2 : null,
                        rowCount : res.id,
                        isChecked : false,
                        category: res.house_type_category,
                    }
                    this.newSelection.push(data)
                }
            })
            console.log(this.newSelection, 'new')
            if (this.$store.state.editMode && this.$store.state.editCadRequestRevisionContent.stopListSelection) {
                this.$store.state.editCadRequestRevisionContent.stopListSelection.forEach((res) => {
                    console.log(res)
                    this.stopFirstSelection = res.option1;
                    this.stopSecondSelection = res.option2;

                    let matchedIndex = null
                    this.newSelection.filter((item, index) => {
                        if(item.rowCount === res.rowCount){
                            matchedIndex = index;
                        }
                    });
                    if (matchedIndex != null) {
                    // Replace the matched item with a new object
                        this.newSelection[matchedIndex] = {
                            option1: res.option1,
                            option2: res.option2,
                            isChecked: res.isChecked,
                            selected: res.selected,
                            category: res.category,
                            rowCount: res.rowCount,
                            text: res.text
                        };
                    }else{
                        if(!res.selected){
                            this.additionalStop.push(
                                {
                                    option1: res.option1,
                                    option2: res.option2,
                                    isChecked: res.isChecked,
                                    selected: res.selected,
                                    category: res.category,
                                    rowCount: res.rowCount,
                                    text: res.text
                                }
                            )
                        }
                    }
                });
            }
        }
    },
    // "$store.state.cadRequestBasicInformation"(val){
        // console.log(val, 'val')
    // },
    // "$store.state.editMode"(val){
    //     // console.log(this.$store.state.cadRequestBasicInformation)
    //     if(val){
    //         if(this.$store.state.editCadRequestRevisionContent.stopListSelection.length > 0){
    //             this.$store.state.editCadRequestRevisionContent.stopListSelection.filter((res) => {
    //                 this.stopFirstSelection = res.option1;
    //                 this.stopSecondSelection = res.option2;
    //                 if(res.option2 == '1'){
    //                     this.stopSelections[res.rowCount - 1].option1 = res.option1;
    //                     this.stopSelections[res.rowCount - 1].option2 = res.option2;
    //                     this.stopSelections[res.rowCount - 1].isChecked = res.isChecked;
    //                     this.stopSelections[res.rowCount - 1].selected = res.SELECTED;
    //                 }


    //                 // this.stopSelections[res.rowCount] = {
    //                 //                                     option1: res.OPTION_1,
    //                 //                                     option2: res.OPTION_2,
    //                 //                                     isChecked: res.isChecked,
    //                 //                                     selected: res.SELECTED,
    //                 //                                 }
    //             })
    //         }
    //     }
    //     console.log(val,'val')
    // }
  },
};
</script>
<style lang=""></style>
